import React, { Component } from "react";
import { Link } from "react-router-dom";
/*eslint-disable*/
export default class NestedMenu extends Component {
  state = { _isOpen: false };
  _openHandler = () => {
    this.setState(prevState => ({ _isOpen: !prevState._isOpen }));
  };
  render() {
    const { item } = this.props;
    const { _isOpen } = this.state;
    const { _openHandler } = this;
    return (
      <li className={_isOpen ? "has-child active" : "has-child"}>
        <a onClick={_openHandler}>{item.label}</a>
        <ul>
          {item.submenu.map(menuItem => {
            if (menuItem.to) {
              return (
                <li>
                  <Link to={menuItem.to}>{menuItem.label}</Link>
                </li>
              );
            } else {
              return (
                <li>
                  <a onClick={menuItem.onClick}>{menuItem.label}</a>
                </li>
              );
            }
          })}
        </ul>
      </li>
    );
  }
}



// WEBPACK FOOTER //
// ./src/_components/Layout/Sidebar/Submenu/NestedMenu/index.js